import { useDispatch, useSelector } from "react-redux";
import AssetDetail from "./AssetDetail";
import { useCallback, useEffect, useMemo, useState } from "react";
import { setLinkedAttachments } from "Store/Component/FleetManagement/FleetManagementAction";
import { setTransferData } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg"
import { CONSTANTS } from "client/utils/constants";
import { setFleetAssetValidation } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import AssetNumberValue from 'Store/AssetManagement/AssetNumber/AssetNumberDispatch';
import userSelectors from "../../../../../redux/UserProfile/selectors";
import { getAssetFleetLinkAttachmentSave } from "Store/FleetManagement/AssetFleetProcessingLinkAttachment/AssetFleetProcessingLinkAttachmentAction";
import { getSaveFleetDisposition } from "Store/FleetManagement/FleetDispositionSave/FleetDispositionSaveAction";

const AssetDetailContainer = (props: any) => {
    const dispatch = useDispatch();
    const setAttachmentChangeFleetId = props?.setAttachmentChangeFleetId
    const assignedToError = props?.assignedToError
    const setAssetDeterminationValue = props?.setAssetDeterminationValue
    const item = props?.item
    const setNewAssetValue = props?.setNewAssetValue
    const dispatchGetFleetAssetValidation = AssetNumberValue.dispatchGetFleetAssetValidation(dispatch);

    const {
        assetDetails,
        orderType,
        setNewAssetError,
        newAssetError
    } = props;

    const {
        attachmentsList,
        linkedAttachments,        
        transferData,
        savedStatus,
        assetValidation,
        userDetails
    }: any = useSelector((state?: any) => ({
        attachmentsList: state.fleetAdminTaskReducer.attachmentList,
        linkedAttachments: state.fleetAdminTaskReducer.linkedAttachments,        
        transferData: state.FleetProcessingReducer.transferData,
        savedStatus: state.adminTaskReducer.savedStatus,
        assetValidation: state.AssetNumber.assetValidation,
        userDetails: userSelectors.getUserDetails(state),
    }));

    const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
    const [newAssetNumberTemp, setNewAssetNumberTemp] = useState<any>();
    const [validAssetFleetIdTemp, setValidAssetFleetIdTemp] = useState<any>({});
    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comments: "",
        popupOutlinebtnOnclick: () => { },
        popupPrimarybtnOnclick: () => { }
      });
      const [penaltyCommentError, setPenaltyCommentError] = useState<string>('');  


    const onChangeAssetDetermination = (e: any, selectedItem:any) => {
        let assetOrderDetailsTemp = transferData ? transferData : []
        transferData?.map((request: any, index: any) => {
            request?.fleetAssetDetails?.map((itemLevel: any) => {
                if(itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId){
                   
                    itemLevel.assetDetermination = selectedItem;
                    if (!selectedItem) {
                        itemLevel.newAssetNumber = "";
                        newAssetError?.map((assetItem: any, assetIndex?: any) => {
                            if (assetItem?.fleetId == assetDetails?.fleetRequestDetailId) {
                                newAssetError.splice(assetIndex, 1)
                            }
                        })
                        setNewAssetError(newAssetError)
                    }
                    dispatch(setTransferData(assetOrderDetailsTemp))
                    setAssetDeterminationValue({fleetDetailId : assetDetails?.fleetRequestDetailId,
                   
                    determinationValue : selectedItem}
                    )
                 }
            })
            
        })
    }

    const onChangeNewAsset = (e?: any , item?: any) => {
        const regEx = /^\d{0,15}(\.\d{1,4})?$/;
        const valArr = item.split('.')
        const checkNumber = regEx.test(item);
        if (!checkNumber || valArr.length > 1) {
            return;
        }else{
        if(item?.length){
            newAssetError?.map((assetItem: any, assetIndex?: any) => {
               if(assetItem?.fleetId == assetDetails?.fleetRequestDetailId){
                newAssetError.splice(assetIndex,1)
               }
            }) 
            setNewAssetError(newAssetError)
        }
        let assetOrderDetailsTemp = transferData ? transferData : []
        transferData?.map((request: any, index: any) => {
            request?.fleetAssetDetails?.map((itemLevel: any) => {
                if(itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId){
                    itemLevel.newAssetNumber = item;
                    dispatch(setTransferData(assetOrderDetailsTemp))
                 }
            })
            
        })
    }
    }

    const onBlurNewAsset = (value?: any) => {
        if (assetDetails?.newAssetNumber?.toString()?.length) {
            let decriptionTxt = (
                <>
                    <p>Are you sure you want to save this Asset Number?</p>
                </>
            );
            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: "CONFIRMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                primaryBtnText: "Yes",
                outlineBtnText: "No",
                isSingleConfirmationBtn: false,
                popupOutlinebtnOnclick: () => {                    
                    let assetOrderDetailsTemp = transferData ? transferData : []
                    transferData?.map((request: any, index: any) => {
                        request?.fleetAssetDetails?.map((itemLevel: any) => {
                            if (itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId) {
                                itemLevel.newAssetNumber = "";
                                dispatch(setTransferData(assetOrderDetailsTemp))
                            }
                        })

                    })
                    let newAssetErrorTemp = newAssetError?.filter((item: any) => item?.fleetId != assetDetails?.fleetRequestDetailId)
                    setNewAssetError(newAssetErrorTemp)
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                },
                popupPrimarybtnOnclick: () => {
                    setNewAssetNumberTemp(value)
                    let isValid = true
                    transferData?.map((transferItem: any) => {
                        transferItem?.fleetAssetDetails?.map((detailsItem: any) => {
                            if (detailsItem?.assetNo != assetDetails?.assetNo) {
                                if (detailsItem?.newAssetNumber == assetDetails?.newAssetNumber) {
                                    let obj: any = {}
                                    obj.fleetId = assetDetails?.fleetRequestDetailId
                                    obj.error = "The New Asset # you have entered is already associated with other item. Please enter a different new asset number that is not been associated."
                                    newAssetError?.push(obj)
                                    setNewAssetError(newAssetError)
                                    isValid = false
                                    return
                                }
                            }
                        })
                    })
                    if (isValid) {
                        dispatchGetFleetAssetValidation([value])
                        setValidAssetFleetIdTemp(assetDetails?.fleetRequestDetailId)
                    }
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                }
            });
        }
    }

    useEffect(() => {
        if (assetValidation?.length && validAssetFleetIdTemp == assetDetails.fleetRequestDetailId) {
            if (assetValidation[0]?.isValid) {
                setNewAssetValue({
                    fleetDetailId: assetDetails.fleetRequestDetailId,
                    newAsset: newAssetNumberTemp
                })
                setNewAssetNumberTemp(null)
            } else {
                let obj: any = {}
                obj.fleetId = assetDetails?.fleetRequestDetailId
                obj.error = "Please enter valid New Asset #"
                newAssetError?.push(obj)
                setNewAssetError(newAssetError)
            }
            setValidAssetFleetIdTemp(null)
            dispatch(setFleetAssetValidation([]))
        }
    }, [assetValidation])

    const hideConfirmationDialog = useCallback(
        () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
        [Popupcontent]
      );

    const onClicktLinkAttachment = (e: any, index: any) => {
        const attachmentButton: any = isAttachmentBtnClicked;
        attachmentButton[index] = !attachmentButton[index];
        setIsAttachmentBtnClicked([...attachmentButton])
        e.preventDefault();
        e.stopPropagation();
    }

    const onCloseLinkAttachment = (e: any) => {
        setIsAttachmentBtnClicked([])
        e.preventDefault();
        e.stopPropagation();
      }

    const getLinkedAttachmentsCount = (linkedAttachment: any) => {
        const filteredArr = linkedAttachment?.filter((x: any) => x?.fleetItemId == assetDetails?.fleetRequestDetailId)
        return filteredArr?.length ? parseInt(filteredArr[0]?.attachments?.length) :  assetDetails?.attachments?.length ?  parseInt(assetDetails?.attachments?.length) : 0;
    }

    const onClickAttachment = (item: any) => {
        let win = window.open();
        if (win) {
            win.document.write(
            '<iframe width="100%" height="100%" src="' +
                item +
                '" frameborder="0" ></iframe>'
            );
        }
    };

    const onChangeLinkAttachment = (event: any, attachment: any, reason: any) => {
        event.preventDefault();
        let obj : any = {}
        let linkedVal = linkedAttachments;
        if((orderType == CONSTANTS.DISPOSITION) || orderType == CONSTANTS.TRANSFER || orderType == CONSTANTS.REACTIVATION){
          setAttachmentChangeFleetId(assetDetails?.fleetRequestDetailId)
        }
        let linkedAttachmenttemp: any = []
        if (event?.target?.checked) {
            let alreadyExist = linkedVal?.filter((item: any) => item?.fleetItemId == assetDetails?.fleetRequestDetailId )
            if(linkedVal?.length && alreadyExist?.length){
                for(let i = 0; i < linkedVal?.length; i++){
                    if(linkedVal[i]?.fleetItemId == assetDetails?.fleetRequestDetailId){
                        linkedVal[i]?.attachments.push({
                            attachmentUrl:attachment?.attachmentUrl,
                            fileName:attachment?.fileName,
                            isFleet: true,
                            mimeType:attachment?.mimeType,
                        })
                        obj.fleetItemId = assetDetails?.fleetRequestDetailId
                        obj.attachments = linkedVal[i]?.attachments
                        let remainingattach = linkedVal?.filter((item: any) => item?.fleetItemId != assetDetails?.fleetRequestDetailId )
                        remainingattach.push(obj)
                        linkedAttachmenttemp = remainingattach?.filter((item: any) => item?.fleetItemId == assetDetails?.fleetRequestDetailId)
                        dispatch(setLinkedAttachments(remainingattach));
                    }
                }
            }else if(!alreadyExist?.length && linkedVal?.length){
                obj.fleetItemId = assetDetails?.fleetRequestDetailId
                obj.attachments = [{
                    attachmentUrl:attachment?.attachmentUrl,
                    fileName:attachment?.fileName,
                    isFleet: true,
                    mimeType:attachment?.mimeType,
                }]
                linkedVal?.push(obj)
                linkedAttachmenttemp = linkedVal?.filter((item: any) => item?.fleetItemId == assetDetails?.fleetRequestDetailId)
                dispatch(setLinkedAttachments(linkedVal));
            }
            else{
                obj.fleetItemId = assetDetails?.fleetRequestDetailId
                obj.attachments = [{
                    attachmentUrl:attachment?.attachmentUrl,
                    fileName:attachment?.fileName,
                    isFleet: true,
                    mimeType:attachment?.mimeType,
                }]
                linkedAttachmenttemp = [obj]?.filter((item: any) => item?.fleetItemId == assetDetails?.fleetRequestDetailId)
                dispatch(setLinkedAttachments([obj]));
            }          
        } else {
            for(let j = 0; j < linkedVal?.length; j++){
            if (linkedVal[j]?.fleetItemId == assetDetails?.fleetRequestDetailId) {
                let removedObj : any = {}
                removedObj.fleetItemId = assetDetails?.fleetRequestDetailId
                removedObj.attachments = linkedVal[j]?.attachments?.filter((x: any) => x.fileName !== attachment.fileName)
                let removedattach = linkedVal?.filter((item: any) => item?.fleetItemId != assetDetails?.fleetRequestDetailId )
                removedattach?.push(removedObj)
                linkedAttachmenttemp = removedattach?.filter((item: any) => item?.fleetItemId == assetDetails?.fleetRequestDetailId)
                dispatch(setLinkedAttachments(removedattach));
            }}
        }
        let payload = {
            orderId: assetDetails?.orderRequestId,
            fleetDetailId: assetDetails?.fleetRequestDetailId,
            attachments: linkedAttachmenttemp[0]?.attachments,
            savedBy: userDetails?.emailId,
            orderAttachments: attachmentsList
        }

        dispatch(getAssetFleetLinkAttachmentSave(payload))
    }

      const isTitleExistOnChange = (e?: any, item?: any) => {
        let assetOrderDetailsTemp = transferData ? transferData : []
        transferData?.map((request: any, index: any) => {
            request?.fleetAssetDetails?.map((itemLevel: any) => {
                if(itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId){
                    itemLevel.titleExists = item;
                    dispatch(setTransferData(assetOrderDetailsTemp))
                 }
            })
            
        })
      }

      const newAssetErrorCheck = (fleetId: any) => {
        return newAssetError?.filter((item: any) => item?.fleetId == fleetId)[0]
      }

    let isSuperAdmin = useMemo(() => {
        let roles = userDetails?.roles?.map((role: any) => role?.roleName) ?? []
        return roles?.includes(CONSTANTS?.SUPER_ADMIN)
    }, [userDetails?.roles])

    const handleOverridePenaltyFeeChange = (e: any, value: any) => {
        let assetOrderDetailsTemp = transferData || []
        transferData?.map((request: any) => {
            request?.fleetAssetDetails?.map((itemLevel: any) => {
                if(itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId){
                    itemLevel.isOverridePenaltyFee = value;
                    if(value){
                        setPenaltyCommentError('Please provide penalty override comment')
                    } else {
                        setPenaltyCommentError('')
                        itemLevel.overridePenaltyComment = '';
                        resetPenaltyFee()
                    }
                    dispatch(setTransferData(assetOrderDetailsTemp))
                 }
            })
            
        })
    }

    const handleOverridePenaltyCommentChange = (e: any, value: any) => {
        let assetOrderDetailsTemp = transferData || []
        transferData?.map((request: any) => {
            request?.fleetAssetDetails?.map((itemLevel: any) => {
                if(itemLevel?.fleetRequestDetailId === assetDetails?.fleetRequestDetailId){
                    itemLevel.overridePenaltyComment = value;
                    validateOverrideComment(value)
                    dispatch(setTransferData(assetOrderDetailsTemp))
                 }
            })
            
        })
    }

    const validateOverrideComment = (comment: string) => {
        let isValid = true
        if(!comment){
            setPenaltyCommentError('Please provide penalty override comment')
            isValid = false
        } else if(comment?.length > 250){
            setPenaltyCommentError('Please provide penalty override comment less than 250 characters')
            isValid = false
        } else {
            setPenaltyCommentError('')
        }
        return isValid
    }


    const resetPenaltyFee = () => {
        let linkedAttachmentTemp = linkedAttachments?.filter((item: any) => item?.fleetItemId == assetDetails?.fleetRequestDetailId)
        let payload: any = {
            fleetRequestTransDispoReactivationDetailId: parseInt(assetDetails?.fleetRequestDetailId),
            orderRequestId: parseInt(assetDetails?.orderRequestId),
            leasedOrOwned: assetDetails?.isLeased ? "Leased" : "Owned",
            titleExists: assetDetails?.titleExists,
            savedBy: userDetails?.emailId,
            assignedTo: assetDetails?.assignedTo,
            isOverridePenaltyFee: assetDetails?.isOverridePenaltyFee,
            overridePenaltyComment: assetDetails?.overridePenaltyComment,
            dispositionPenaltyFee: assetDetails?.dispositionPenaltyFee,
            orderRequestAttachments: attachmentsList,
            itemDetailAttachments: linkedAttachmentTemp[0]?.attachments
        }
        dispatch(getSaveFleetDisposition(payload))
    }

    const onBlurOverridePenaltyComment = () => {
        if (assetDetails?.isOverridePenaltyFee) {
            let isValid = validateOverrideComment(assetDetails?.overridePenaltyComment)
            if (isValid) {
                resetPenaltyFee()
            }
        }
    }
    

    return (
        <AssetDetail
            assetDetails={assetDetails} 
            orderType={orderType}
            
            onChangeAssetDetermination={onChangeAssetDetermination}
            isAttachmentBtnClicked = {isAttachmentBtnClicked}
            onClicktLinkAttachment={onClicktLinkAttachment}
            onCloseLinkAttachment={onCloseLinkAttachment}
            getLinkedAttachmentsCount={getLinkedAttachmentsCount}
            linkedAttachments={linkedAttachments}
            attachmentsList={attachmentsList}
            onChangeLinkAttachment={onChangeLinkAttachment}
            onClickAttachment={onClickAttachment}
            // onAssignedToChange = {onAssignedToChange}
            assignedToError = {assignedToError}
            item = {item}
            onChangeNewAsset = {onChangeNewAsset}
            onBlurNewAsset = {onBlurNewAsset}
            Popupcontent = {Popupcontent}
            hideConfirmationDialog = {hideConfirmationDialog}
            newAssetError = {newAssetError}
            savedStatus = {savedStatus}
            isTitleExistOnChange={isTitleExistOnChange}
            newAssetErrorCheck = {newAssetErrorCheck}
            isSuperAdmin={isSuperAdmin}
            handleOverridePenaltyFeeChange={handleOverridePenaltyFeeChange}
            handleOverridePenaltyCommentChange={handleOverridePenaltyCommentChange}
            onBlurOverridePenaltyComment={onBlurOverridePenaltyComment}
            penaltyCommentError={penaltyCommentError}
        />
    )
}

export default AssetDetailContainer;